export enum DocumentType {
    Contract = 1,
    Invoice = 2,
    Receipt = 3,
    InsurancePolicy = 4,
    License = 5,
    Other = 6,
}
